<script>
</script>

<div class="logo">
  <a href="https://theoutlier.co.za">
    <img src="./images/outlier-logo.png" alt="Outlier Logo" />
    <div class="logo-tagline">
      Making sense of the world around us through data
    </div>
  </a>
</div>

<style>
  .logo a {
    text-decoration: none;
  }
  .logo {
    width: 380px;
    margin-bottom: 10px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
  }
  .logo img {
    width: 100%;
  }
  .logo-tagline {
    background: var(--red);
    padding: 5px;
    color: #fff;
    font-weight: 700;
    text-align: center;
    font-family: var(--headerFont);
  }
</style>
